








































































import Vue, { PropType } from "vue";
import log from "loglevel";

import {
  PostPurchaseSettlementGoldRequest,
  PostPurchaseSettlementGoldResponse
} from "@/containers/purchaseSettlementGold/api";

export interface PurchaseSettlementGoldProps {
  locale: string;
  lang: any;
  balance: number;
  canPayment: boolean;
  itemName: string;
  itemPrice: number;
  goldPurchaseUrl: string;
  goldPurchaseTarget: string;
  session: string;
  errorUrl: string;
  postPurchaseSettlementGold: any;
  updateIsBusy: any;
}

export default Vue.extend({
  name: "vc-purchase-settlement-gold",
  props: {
    locale: {
      type: String as PropType<PurchaseSettlementGoldProps["locale"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<PurchaseSettlementGoldProps["lang"]>,
      default: () => {}
    },
    balance: {
      type: Number as PropType<PurchaseSettlementGoldProps["balance"]>,
      default: 0
    },
    canPayment: {
      type: Boolean as PropType<PurchaseSettlementGoldProps["canPayment"]>,
      default: false
    },
    itemName: {
      type: String as PropType<PurchaseSettlementGoldProps["itemName"]>,
      default: ""
    },
    itemPrice: {
      type: Number as PropType<PurchaseSettlementGoldProps["itemPrice"]>,
      default: 0
    },
    goldPurchaseUrl: {
      type: String as PropType<PurchaseSettlementGoldProps["goldPurchaseUrl"]>,
      default: ""
    },
    goldPurchaseTarget: {
      type: String as PropType<
        PurchaseSettlementGoldProps["goldPurchaseTarget"]
      >,
      default: ""
    },
    session: {
      type: String as PropType<PurchaseSettlementGoldProps["session"]>,
      default: ""
    },
    errorUrl: {
      type: String as PropType<PurchaseSettlementGoldProps["errorUrl"]>,
      default: ""
    },
    // actionsToProps
    postPurchaseSettlementGold: {
      type: Function as PropType<
        PurchaseSettlementGoldProps["postPurchaseSettlementGold"]
      >,
      default: () => {}
    },
    updateIsBusy: {
      type: Function as PropType<PurchaseSettlementGoldProps["updateIsBusy"]>,
      default: () => {}
    }
  },
  methods: {
    async executionPostPurchaseSettlementGold() {
      this.updateIsBusy(true);
      const requestData = {
        session: this.session
      } as PostPurchaseSettlementGoldRequest;
      try {
        const res: PostPurchaseSettlementGoldResponse = await this.postPurchaseSettlementGold(
          requestData
        );
        window.location.href = res.returnUrl;
      } catch (error) {
        log.error(error);

        window.location.href = this.errorUrl + "?type=default_error";
        throw error;
      } finally {
        this.updateIsBusy(false);
      }
    },
    getGoldPriceText(price: string) {
      return Intl.NumberFormat("ja-JP").format(Number(price)) + " GOLD";
    }
  }
});
